module.exports = __webpack_public_path__ + "media/components/assets/icons/youtube_footer-e748a450b5947af5a7dc079fa01f6904.svg";